import React, {useEffect, useState, useTransition} from 'react';
import {useTheme} from "../../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullStr,
    getArrLen,
    getHighlightedMatchedText,
    getJsonValue,
    isBoolTrue,
    isJsonValueTrue,
    shuffleList,
    sortJsonListAdvance
} from "../../../common/fusion-ui/utils/ReactUtils";
import {isCurrUserRoleAdmin, printError, printLog, sendRequest} from "../../utils/AppUtils";
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {GenRouteUrls, Keys, ModuleFieldsData, Modules, ReqUrls} from "../../config/AppConfig";
import {Img_CreateAlbum_FormDialog, InternalPageHeaderBar, RecordsPagination, ThemedConfirmDialog, ThemedIconButton} from "../../index";
import {Avatar, Flexbox, Label, LoadingSection, NullMsgLabel, Section} from '../../../common/fusion-ui';
import {Constants, CssVariant, DefStrNA} from 'common/fusion-ui/config/FusionConfig';
import {useConfig} from "../../context/ConfigProvider";
import {AnimationType, FramerAnimator} from "../../../common/fusion-ui/animation/FramerAnimator";

const ImagePanel = React.memo(({
                                   recordList = [], loadingStatus = {}, onRecordsUpdate,
                               }) => {
    const TAG = "ImagePanel";
    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();

    const animator = new FramerAnimator();

    const moduleName = Modules.Images;
    const mf = ModuleFieldsData[moduleName];
    // const {isScreenXs, isScreenSm, isScreenMd, isScreenResizing} = useScreenSize();
    const {updateConfig} = useConfig();

    const PAGINATION_RECORD_LIMITS = [3, 5, 10, 15, 20];
    const DEF_PGNTN_RECORD_LIMIT = PAGINATION_RECORD_LIMITS[0];
    const DEF_PGNTN_START_INDEX = 1;

    const SEARCH_BY_PARAMS = {
        anything: {
            name: 'Anything'
        }, title: {
            name: mf.albumName.titleAlt
        }, desc: {
            name: mf.albumDesc.titleAlt
        },
    };
    const SORT_BY_PARAMS = {
        title: {
            name: mf.albumName.titleAlt, sortKey: mf.albumName.column,
        }, desc: {
            name: mf.albumDesc.titleAlt, sortKey: mf.albumDesc.column,
        },
    };

    const Fields = {
        recordList: 'recordList',
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        searchInputValue: 'searchInputValue',
        searchBySelectedOption: 'searchBySelectedOption',

        sortBySelectedOption: 'sortBySelectedOption',
        isSortByOrderAsc: 'isSortByOrderAsc',

        pagination_currPageNum: 'pagination_currPageNum',
        pagination_currPageLimit: 'pagination_currPageLimit',

        openCreateAlbumDialog: 'openCreateAlbumDialog',
        createAlbumDialog_editMode: 'createAlbumDialog_editMode',

        recordDeleteBtn_Disable: 'recordDeleteBtn_Disable',
        recordDeleteBtn_AsLoading: 'recordDeleteBtn_AsLoading',
        currSelectedRecordId: 'currSelectedRecordId',
        showDeleteDialog: 'showDeleteDialog',
    };

    const [fieldsData, setFieldsData] = useState({});

    const [sortListPending, startSortListTransition] = useTransition();
    const [searchListPending, startSearchListTransition] = useTransition();


    useEffect(() => {
        if (!checkNullStr(getField(Fields.pagination_currPageNum))) {
            updateConfig(Keys.tracker_currPageModule, moduleName);
            updateConfig(Keys.tracker_currPageTag, TAG);
            updateField(Fields.pagination_currPageNum, DEF_PGNTN_START_INDEX);
            updateField(Fields.pagination_currPageLimit, DEF_PGNTN_RECORD_LIMIT);
            updateField(Fields.searchBySelectedOption, SEARCH_BY_PARAMS.anything.name);
            updateField(Fields.sortBySelectedOption, SORT_BY_PARAMS.title.name);
            updateField(Fields.isSortByOrderAsc, true);

        }
    }, []);

    useEffect(() => {
        log('useEffect.recordList:', recordList, 'loadingStatus:', loadingStatus);
        updateField(Fields.isDataLoading, true);
        updateField(Fields.recordList, recordList);
        updateField(Fields.isDataFound, isJsonValueTrue(loadingStatus, 'success'));
        updateField(Fields.dataLoadingMsg, getJsonValue(loadingStatus, 'msg'));
        updateField(Fields.isDataLoading, !isJsonValueTrue(loadingStatus, 'loaded'));
    }, [recordList, loadingStatus]);

    return (<>
        {createPanel()}
        {createAlbumFormDialog()}
        {createRecordDeleteDialog()}
    </>);

    //======================UI Functions start=====================
    function createPanel() {
        return <div className={''}>
            <div className={'position-relative'}>
                {/*header-bar*/}
                <InternalPageHeaderBar
                    className={'mx-1x'}
                    px={0}

                    moduleName={moduleName}

                    uploadUrl={GenRouteUrls.img_uploadPage}
                    recomUrl={GenRouteUrls.img_recomPage}

                    showSearch={true}
                    showSort={false}
                    showSearchBy={true}
                    searchByParams={SEARCH_BY_PARAMS}
                    sortByParams={SORT_BY_PARAMS}

                    recordsLen={getArrLen(getRecordList())}
                    filteredRecordsLen={getArrLen(getRecordList(true))}
                    searchValue={getField(Fields.searchInputValue)}
                    searchByDefOption={getField(Fields.searchBySelectedOption)}
                    sortByDefOption={getField(Fields.sortBySelectedOption)}
                    isSorting={sortListPending}
                    isSearching={searchListPending}
                    isSortAsc={isFieldTrue(Fields.isSortByOrderAsc)}

                    onUploadClick={(e) => {
                    }}
                    onRecomClick={(e) => {
                    }}
                    onSearchChange={(e, value) => handleSearchInputChange(value)}
                    onSearchBy={(name, item, index) => {
                        updateField(Fields.searchBySelectedOption, name);
                        handleSearchInputChange(getField(Fields.searchInputValue), name);
                    }}
                    onSort={(name, item, index, sortKey) => {
                        handleSortByChange(name, sortKey);
                    }}

                    leftControls={(isCurrUserRoleAdmin()) && <ThemedIconButton
                        className={'fs-sm fw-semi-bold text-nowrap'}
                        outlined={true}
                        mr={2}
                        // height={'28px'}
                        size={'28px'}
                        // text={`Create Album`}
                        tooltip={`Create Album`}
                        icon={'https://img.icons8.com/material-outlined/96/228BE6/add-image.png'}
                        iconAsImage={true}
                        iconSize={'15px'}
                        variant={theme.primaryBlue}
                        hoverBgColor={theme.primaryBlue10}
                        hoverBorderColor={theme.primaryBlue}
                        rippleColor={theme.primaryBlue50}
                        onClick={() => updateField(Fields.openCreateAlbumDialog, true)}
                    />}
                />

                {/*body*/}
                {<div className={'position-relative mt-1'}>
                    {/* record lists */}
                    {(isFieldTrue(Fields.isDataFound) && isFieldTrue(Fields.isDataFound)) && animator.setAnimationType(AnimationType.SLIDE_UP).renderChildren(<div
                        className={""}>
                        {getRecordListToRender().map((item, index) => {
                            const albumRecordId = getJsonValue(item, mf.albumId.column);
                            return <Section key={index + getJsonValue(item, mf.albumName.column, DefStrNA)}
                                            className={'mb-3 app-section hover'}
                                            borderColor={theme.text20}>
                                <div>
                                    {/*title, desc*/}
                                    <div>
                                        <div className={''}>
                                            {/*albumName & edit*/}
                                            <div>
                                                <Flexbox className={''} justifyAt={'start'} alignAt={'start'}>
                                                    <Label className={'m-0 p-0 fw-semi-bold'} color={theme.text}>
                                                        {highlightSearchMatchedText(getJsonValue(item, mf.albumName.column, DefStrNA), SEARCH_BY_PARAMS.title.name)}
                                                    </Label>
                                                    {/*edit*/}
                                                    <ThemedIconButton
                                                        className={'text-nowrap fs-sm'}
                                                        tooltip={`Edit Album`}
                                                        icon={'bi bi-pencil-square'}
                                                        size={'26px'}
                                                        circular={true}
                                                        variant={theme.primaryBlue}
                                                        color={theme.primaryBlue}
                                                        hoverBgColor={theme.primaryBlue}
                                                        bgColor={'transparent'}
                                                        mx={2}
                                                        onClick={() => {
                                                            updateField(Fields.currSelectedRecordId, albumRecordId);
                                                            updateField(Fields.createAlbumDialog_editMode, true);
                                                            updateField(Fields.openCreateAlbumDialog, true);
                                                        }}
                                                    />
                                                </Flexbox>
                                            </div>
                                            {/*albumDesc*/}
                                            <div>
                                                <Label className={'m-0 p-0'} color={theme.text}>
                                                    {highlightSearchMatchedText(getJsonValue(item, mf.albumDesc.column, DefStrNA), SEARCH_BY_PARAMS.desc.name)}
                                                </Label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* imageList*/}
                                    <div className={'mt-1'}>
                                        <Flexbox className={''} wrap={'wrap'}>
                                            {checkNullArr(getJsonValue(item, mf.imageList.column)) ? getJsonValue(item, mf.imageList.column).map((imgItem, imgIndex) => {
                                                return animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(100 * imgIndex).render(<div key={imgIndex + 'xsert'}
                                                                                                                                              className={'m-0 p-0 w-auto p-1'}>
                                                    <Avatar
                                                        wrapperClassName={''}
                                                        circular={false}
                                                        bordered={false}
                                                        imgClassName={'rounded-3'}
                                                        showFullPreviewDialog={true}
                                                        width={'180px'}
                                                        height={'130px'}
                                                        defAvatarImg={Constants.imgVector}
                                                    >
                                                        {getJsonValue(imgItem, mf.title.column)}
                                                    </Avatar>
                                                </div>)
                                            }) : <NullMsgLabel color={theme.text70}>No image present</NullMsgLabel>}
                                        </Flexbox>
                                    </div>

                                    {/*controls*/}
                                    {isCurrUserRoleAdmin() && <Flexbox
                                        justifyAt={'end'}
                                        alignAt={'center'}>
                                        {/*edit*/}
                                        <ThemedIconButton
                                            className={' text-nowrap fs-sm'}
                                            tooltip={`Edit Images`}
                                            icon={'bi bi-pencil'}
                                            variant={theme.primaryBlue}
                                            size={'26px'}
                                            outlined={true}
                                            circular={true}
                                            mx={2}
                                            href={`${GenRouteUrls.img_editPage}${albumRecordId}`}
                                        />

                                        {/*delete*/}
                                        <ThemedIconButton
                                            className={''}
                                            tooltip={'Delete Album'}
                                            m={1}
                                            ml={2}
                                            variant={'red'}
                                            bgColor={theme.textWhite}
                                            hoverBgColor={'red'}
                                            outlined={true}
                                            icon={'bi bi bi-trash'}
                                            iconSize={'11px'}
                                            size={'26px'}
                                            loadingVariant={CssVariant.danger}
                                            asLoading={isFieldTrue(Fields.recordDeleteBtn_AsLoading) && getField(Fields.currSelectedRecordId) == albumRecordId}
                                            disabled={isFieldTrue(Fields.recordDeleteBtn_Disable) && getField(Fields.currSelectedRecordId) == albumRecordId}
                                            onClick={() => {
                                                updateField(Fields.currSelectedRecordId, albumRecordId);
                                                updateField(Fields.showDeleteDialog, true);
                                            }}
                                        />
                                    </Flexbox>}
                                </div>
                            </Section>
                        })}
                    </div>)}

                    {/*No search-found*/}
                    {((isSearchOngoing() && !searchListPending && checkNullArr(getRecordList()) && !checkNullArr(getRecordList(true)))) &&
                        <Flexbox className={'h-80 select-none'} justifyAt={'center'} alignAt={'center'} direction={'column'} wrap={'wrap'}>
                            <Label className={'m-1 w-100 fs-xxl fw-semi-bold'} color={theme.primary50}>
                                Search not found!
                            </Label>
                        </Flexbox>}

                    {<LoadingSection
                        labelClassName={'m-1 w-100 fs-xxl fw-semi-bold'}
                        heightClass={75}
                        color={theme.primary50}
                        // success={isFieldTrue(Fields.isDataFound)}
                        // loading={isFieldTrue(Fields.isDataLoading)}
                        success={isJsonValueTrue(loadingStatus, 'success')}
                        loading={!isJsonValueTrue(loadingStatus, 'loaded')}
                        // loading={!isJsonValueTrue(loadingStatus, 'success') || !isJsonValueTrue(loadingStatus, 'loaded')}
                        msg={getField(Fields.dataLoadingMsg)}
                    />}
                </div>}

                {/* Pagination */}
                <RecordsPagination
                    id={TAG}
                    position={'sticky'}
                    bottom={'-.1rem'}
                    zIndex={1}
                    bgColor={theme.primary10Opaque}
                    totalRecords={getArrLen(getRecordList(true))}
                    totalRecordsToRender={getArrLen(getRecordListToRender())}
                    recordLimits={PAGINATION_RECORD_LIMITS}
                    onPageChange={(e, newPageIndex) => {
                        // log('RecordsPagination.onLimitChange.newPageIndex:', newPageIndex);
                        updateField(Fields.pagination_currPageNum, newPageIndex);
                    }}
                    onLimitChange={(newLimit, newPageIndex) => {
                        // log('RecordsPagination.onLimitChange.newLimit:', newLimit, 'newPageIndex:', newPageIndex);
                        updateField(Fields.pagination_currPageLimit, newLimit);
                        updateField(Fields.pagination_currPageNum, newPageIndex);
                    }}
                />

            </div>
        </div>
    }

    function createAlbumFormDialog() {
        return <Img_CreateAlbum_FormDialog
            updateOnly={isFieldTrue(Fields.createAlbumDialog_editMode)}
            updateRecordId={getField(Fields.currSelectedRecordId)}
            open={isFieldTrue(Fields.openCreateAlbumDialog)}
            onHide={() => {
                // updateField(Fields.openCreateAlbumDialog, false);
            }}
            onCancel={() => {
                updateField(Fields.openCreateAlbumDialog, false);
                updateField(Fields.createAlbumDialog_editMode, false);
                updateField(Fields.currSelectedRecordId, null);
            }}
            onSuccess={(fetchedData, message, formData) => {
                log('createAlbumFormDialog.onSuccess.formData:', formData, 'fetchedData:', fetchedData);
                const recordList = getRecordList().map((item) => {
                    // if (getJsonValue(item, mf.albumId) == getJsonValue(formData, mf.albumId)) {
                    if (getJsonValue(item, mf.albumId.column) == getJsonValue(formData, mf.albumId.column)) {
                        return {
                            ...item,
                            [mf.albumName.column]: getJsonValue(formData, mf.albumName.column),
                            [mf.albumDesc.column]: getJsonValue(formData, mf.albumDesc.column),
                        }
                    } else {
                        return item;
                    }
                });
                updateField(Fields.recordList, recordList);

                updateField(Fields.openCreateAlbumDialog, false);
                updateField(Fields.createAlbumDialog_editMode, false);
                updateField(Fields.currSelectedRecordId, null);
                // log('createAlbumFormDialog.onSuccess.fetchedData:', fetchedData, 'message:', message);
                // log('createAlbumFormDialog.onSuccess.formData:', formData, 'recordList:', recordList);
            }}
        />
    }

    function createRecordDeleteDialog() {
        return <ThemedConfirmDialog
            open={isFieldTrue(Fields.showDeleteDialog)}
            onCancel={() => updateField(Fields.showDeleteDialog, false)}
            onHide={() => updateField(Fields.currSelectedRecordId, null)}
            title={`Delete Album`}
            subMsg={getJsonValue(getRecordList().find(item => getField(Fields.currSelectedRecordId) == getJsonValue(item, mf.albumId.column)), mf.albumName.column)}
            operation={'delete'}
            target={'this album'}
            onConfirm={() => {
                handleRecordDelete();
            }}
        />
    }

    function handleRecordDelete() {
        const fun = 'handleRecordDelete:';
        const recordId = getField(Fields.currSelectedRecordId);
        if (checkNullStr(recordId)) {
            updateField(Fields.recordDeleteBtn_Disable, true);
            updateField(Fields.recordDeleteBtn_AsLoading, true);
            try {
                const REQUEST_OPTIONS = {recordId: recordId};
                sendRequest({
                    reqUrl: ReqUrls.img__mainPage_delete_record, reqOptions: REQUEST_OPTIONS, onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);
                        updateField(Fields.showDeleteDialog, false)

                        const success = isJsonValueTrue(fetchedData, 'success');
                        const message = getJsonValue(fetchedData, 'message');
                        if (success) {
                            toast(message, CssVariant.success);
                            log(fun, 'getRecordList-old.before:', getArrLen(getRecordList()));

                            //Remove this recordId item from recordList
                            const recordList = getRecordList().filter((item) => recordId != getJsonValue(item, mf.albumId.column));
                            updateField(Fields.recordList, recordList);
                            if (onRecordsUpdate) onRecordsUpdate(recordList);
                            // log(fun, 'getRecordList-after.length:', getArrLen(recordList));

                            if (!checkNullArr(recordList)) {
                                updateField(Fields.isDataFound, false);
                                updateField(Fields.dataLoadingMsg, "No records found!");
                            }
                        } else {
                            toast(message, CssVariant.danger);
                        }
                        updateField(Fields.currSelectedRecordId, null);
                        updateField(Fields.recordDeleteBtn_Disable, false);
                        updateField(Fields.recordDeleteBtn_AsLoading, false);
                    }), onError: ((error) => {
                        logErr(fun, error);
                        updateField(Fields.recordDeleteBtn_Disable, false);
                        updateField(Fields.recordDeleteBtn_AsLoading, false);
                    }),
                });
            } catch (error) {
                logErr(fun, error);
                updateField(Fields.recordDeleteBtn_Disable, false);
                updateField(Fields.recordDeleteBtn_AsLoading, false);
            }
        } else {
            toast('Record-id not found!', CssVariant.danger);
        }
    }

    //======================Util Functions start=====================
    function handleSearchInputChange(inputValue, searchByOption = getField(Fields.searchBySelectedOption)) {
        const fun = 'handleSearchInputChange:';
        try {
            // if (inputValue == InputFocusShortcutKey) {
            //     return;
            // }
            updateField(Fields.searchInputValue, inputValue);
            // startSearchListTransition(() => {
            // Filter search query based on selected search filter
            const inputValueL = (inputValue + '').toLowerCase();
            let recordList = getRecordList();
            if (checkNullStr(inputValue) && checkNullArr(recordList)) {
                recordList = recordList.map((item) => {
                    const title = (getJsonValue(item, mf.albumName.column) + '').toLowerCase();
                    const desc = (getJsonValue(item, mf.albumDesc.column) + '').toLowerCase();

                    let matched = false;
                    switch (searchByOption) {
                        case SEARCH_BY_PARAMS.anything.name:
                            matched = (title + desc).includes(inputValueL);
                            break;
                        case SEARCH_BY_PARAMS.title.name:
                            matched = title.includes(inputValueL);
                            break;
                        case SEARCH_BY_PARAMS.desc.name:
                            matched = desc.includes(inputValueL);
                            break;
                    }
                    return {
                        ...item, searched: matched
                    }
                });
                // log(fun, 'inputValue:', inputValue, 'searchBy:', getField(Fields.searchBySelectedOption), 'recordList', recordList);
            }

            // update-list
            startSearchListTransition(() => {
                updateField(Fields.recordList, recordList);
            });
        } catch (error) {
            logErr(fun, error);
            toast('Search failed, please try again', CssVariant.danger);
        }
    }

    function handleSortByChange(name, sortKey) {
        const fun = 'handleSortByChange:';
        try {
            startSortListTransition(() => {
                const sortOption = getField(Fields.sortBySelectedOption);
                const order = name == sortOption ? !isFieldTrue(Fields.isSortByOrderAsc) : isFieldTrue(Fields.isSortByOrderAsc);

                updateField(Fields.isSortByOrderAsc, order);
                updateField(Fields.sortBySelectedOption, name);

                updateField(Fields.recordList, sortJsonListAdvance(shuffleList(getRecordList()), sortKey, order));
            });
        } catch (error) {
            toast('Sort failed, please try again', CssVariant.danger);
            logErr(fun, error);
        }
    }

    function highlightSearchMatchedText(text, searchByParam) {
        const can = (getField(Fields.searchBySelectedOption) == SEARCH_BY_PARAMS.anything.name || getField(Fields.searchBySelectedOption) == searchByParam);
        return can ? getHighlightedMatchedText(text, getField(Fields.searchInputValue)) : text;
    }

    function getRecordList(searchedOnly = false) {
        if (checkNullArr(getField(Fields.recordList))) {
            if (isBoolTrue(searchedOnly) && isSearchOngoing()) {
                return getField(Fields.recordList).filter(item => isJsonValueTrue(item, 'searched'))
            }
            return getField(Fields.recordList);
        }
        return [];
    }

    function getRecordListToRender() {
        return getRecordList(true).slice((getField(Fields.pagination_currPageNum) - 1) * getField(Fields.pagination_currPageLimit), getField(Fields.pagination_currPageNum) * getField(Fields.pagination_currPageLimit));
    }

    function isSearchOngoing() {
        return checkNullStr(getField(Fields.searchInputValue));
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default ImagePanel;
